import { MemoizedSelector, MemoizedSelectorWithProps, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { EntriesState } from '../../../../../core/features/store/base-feature-state';
import { TinyCart } from '../../../../../core/model';
import { PyStateUtils } from '../../../../../core/state';
import { CartState, StateWithCart } from '../cart-state';
import { getCartState } from './feature.selector';

export const getTinyCartsState: MemoizedSelector<
  StateWithCart,
  StateUtils.LoaderState<EntriesState<TinyCart | undefined>>
> = createSelector(getCartState, (state: CartState) => (state && state.tinyCarts) || PyStateUtils.initialLoaderState);

export const getTinyCartsLoading: MemoizedSelector<StateWithCart, boolean> = createSelector(
  getTinyCartsState,
  (state: StateUtils.LoaderState<EntriesState<TinyCart>>) => StateUtils.loaderLoadingSelector(state)
);

export const getTinyCartsLoaded: MemoizedSelector<StateWithCart, boolean> = createSelector(
  getTinyCartsState,
  (state: StateUtils.LoaderState<EntriesState<TinyCart>>) => StateUtils.loaderSuccessSelector(state)
);

export const getTinyCartEntries: MemoizedSelector<StateWithCart, EntriesState<TinyCart> | undefined> = createSelector(
  getTinyCartsState,
  (state: StateUtils.LoaderState<EntriesState<TinyCart>>) =>
    (state &&
      !StateUtils.loaderLoadingSelector(state) &&
      StateUtils.loaderSuccessSelector(state) &&
      StateUtils.loaderValueSelector(state)) ||
    undefined
);

export const getTinyCarts: MemoizedSelector<StateWithCart, TinyCart[] | undefined> = createSelector(
  getTinyCartEntries,
  (state: EntriesState<TinyCart>) => (state && Object.values(state)) || undefined
);

export const getTinyCart: MemoizedSelectorWithProps<StateWithCart, any, TinyCart | undefined> = createSelector(
  getTinyCartEntries,
  (state: EntriesState<TinyCart>, props) => (state && state[props.cartType]) || undefined
);
